<template>
  <div>
    <a-card :bordered="false">
      <div slot="title">
        <a-space align="center">
          <div class="title_icon"></div>
          <div
            class="ant-descriptions-title"
            style="font-size: 16px; margin-bottom: 0px"
          >
            房源管理
          </div>
        </a-space>

        <a-button type="primary" style="float: right">构建房源</a-button>
      </div>

      <div class="search-area">
        <a-form layout="inline">
          <a-form-item label="提交时间">
            <a-range-picker
              style="width: 250px"
              :placeholder="['开始日期', '结束日期']"
            />
          </a-form-item>

          <a-form-item label="房源编号">
            <a-input-search
              placeholder="多个关键词用“+”隔开"
              style="width: 220px"
            />
          </a-form-item>

          <a-form-item label="房源名称">
            <a-input-search placeholder="房源名称" style="width: 220px" />
          </a-form-item>

          <br />
          <div style="margin-top: 4px">
            <a-form-item label="详细地址">
              <a-input-search placeholder="详细地址" style="width: 250px" />
            </a-form-item>

            <a-form-item label="权利人名称">
              <a-input-search placeholder="权利人名称" style="width: 250px" />
            </a-form-item>

            <a-button type="primary" style="margin-top: 5px">重置</a-button>
          </div>
        </a-form>
      </div>

      <a-table
        :columns="columns"
        :data-source="data"
        rowKey="id"
        :pagination="{ pageSize: 10, total: data.length }"
        :scroll="{ x: 1200 }"
      >
        <template slot="operation">
          <a style="color: #1890ff">编辑</a>
          <a-divider type="vertical" />
          <a style="color: #1890ff" @click="changeToDetail(1)">详情</a>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "序号", dataIndex: "index", width: 80, key: "index" },
        {
          title: "封面",
          dataIndex: "cover",
          width: 100,
          key: "cover",
          scopedSlots: { customRender: "cover" },
        },
        { title: "房源名称", dataIndex: "name", width: 250, key: "name" },
        { title: "房源编号", dataIndex: "code", width: 150, key: "code" },
        { title: "租赁用途", dataIndex: "usage", width: 100, key: "usage" },
        { title: "详细地址", dataIndex: "address", width: 250, key: "address" },
        {
          title: "最后编辑时间",
          dataIndex: "updateTime",
          width: 180,
          key: "updateTime",
        },
        {
          title: "操作",
          key: "operation",
          fixed: "right",
          width: 180,
          scopedSlots: { customRender: "operation" },
        },
      ],
      data: [
        {
          id: "1",
          index: 1,
          name: "上海市金山区漕泾中一东路51-81号",
          code: "FY202518452",
          usage: "商业",
          address: "上海市金山区漕泾中一东路51-81号",
          updateTime: "2025-06-09 16:23:30",
        },
        {
          id: "2",
          index: 2,
          name: "上海市金山区漕泾运石路12-104号",
          code: "FY202518451",
          usage: "商业",
          address: "上海市金山区漕泾运石路12-104号",
          updateTime: "2025-06-09 16:19:54",
        },
        {
          id: "3",
          index: 3,
          name: "上海市金山区亭林镇李伟公路2115号",
          code: "FY202518114",
          usage: "商业",
          address: "上海市金山区亭林镇李伟公路2115号",
          updateTime: "2025-05-30 09:50:20",
        },
        {
          id: "4",
          index: 4,
          name: "上海市金山区亭林镇南亭公路5858号",
          code: "FY202517527",
          usage: "仓储",
          address: "亭林镇南亭公路5858号",
          updateTime: "2025-05-19 10:08:08",
        },
      ],
    };
  },
  methods: {
    changeToDetail(val) {
      this.$emit("changeToDetail", {
        test: val,
      });
    },
  },
};
</script>

<style scoped>
.my-lease {
  background-color: #fff;
  padding: 20px;
}

.search-area {
  margin-bottom: 20px;
}

a-form-item {
  margin-bottom: 15px;
}

/* 关键部分：修复输入框宽度异常 */
.search-area /deep/ .ant-input {
  width: 100% !important;
  height: 32px !important;
  padding: 4px 11px !important;
  border-radius: 4px !important;
  line-height: 1.5 !important;
}

.title_icon {
  width: 6px;
  height: 22px;
  background: #007aff;
}
</style>